"use strict";
/**
 *
 * FormField/useFormField
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const FormContext_1 = require("../FormContext");
const react_plumb_1 = require("@domonda/react-plumb");
function useFormField(props) {
    const form = FormContext_1.useFormContext();
    const memoProps = react_plumb_1.useDeepMemoOnValue(props);
    const { path } = memoProps, config = __rest(memoProps, ["path"]);
    const plumbRef = react_1.useRef(null);
    const [field] = react_1.useMemo(() => {
        // dispose on field change
        if (plumbRef.current && !plumbRef.current.disposed) {
            plumbRef.current.dispose();
        }
        return form.makeFormField(path, config);
    }, [form, memoProps]);
    if (plumbRef.current !== field.plumb) {
        plumbRef.current = field.plumb;
    }
    react_1.useEffect(() => () => {
        if (plumbRef.current && !plumbRef.current.disposed) {
            plumbRef.current.dispose();
        }
    }, []);
    const [state] = react_plumb_1.usePlumbState({ plumb: field.plumb });
    return Object.assign(Object.assign({}, field), { state, value: state.value });
}
exports.useFormField = useFormField;
